import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, mergeProps as _mergeProps, withCtx as _withCtx } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", null, "Demo Snapshots", -1)
const _hoisted_2 = { key: 3 }
const _hoisted_3 = {
  key: 0,
  class: "modal-form"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "nonfield-errors" }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("b", null, "Whoops! Something went wrong, please try again.")
  ])
], -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "form-body" }
const _hoisted_7 = ["onClick"]

import { ref, onMounted, computed } from "vue";
import TandemModal from "@/components/TandemModal.vue";
import TandemSelect from "@/components/TandemSelect.vue";
import LoadingIndicator from "@/components/LoadingIndicator.vue";
import {
  getDemoCohort,
  resetDemoCohort,
  Blueprint,
  buildBlueprint,
  Milestone,
  DemoCohort,
} from "@/services/snapshotService";

type BuildStatus = "reset" | "building" | "error" | "default";


export default /*#__PURE__*/_defineComponent({
  __name: 'SnapshotModal',
  props: {
    demoCohortId: {},
    successUrl: {}
  },
  setup(__props: any) {

const props = __props;



const demoCohort = ref<DemoCohort>();
const status = ref<BuildStatus>("default");
const selectedBlueprint = ref<Blueprint>();
const selectedMilestone = ref<Milestone>();

const blueprints = computed<Blueprint[]>(
  () => demoCohort.value?.blueprints || []
);

const milestones = computed(() => {
  return selectedBlueprint.value?.milestones;
});

const handleBuild = async () => {
  if (selectedBlueprint.value && selectedMilestone.value) {
    try {
      status.value = "reset";
      await resetDemoCohort(props.demoCohortId);
      status.value = "building";
      await buildBlueprint(
        props.demoCohortId,
        selectedBlueprint.value.id,
        selectedMilestone.value.timestamp
      );
      window.location.href = props.successUrl;
    } catch {
      status.value = "error";
    }
  }
};

onMounted(async () => {
  demoCohort.value = await getDemoCohort(props.demoCohortId);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(TandemModal, _mergeProps(_ctx.$attrs, {
    "click-to-close": false,
    class: "demo-modal modal show modal-drilldown"
  }), {
    title: _withCtx(() => [
      _hoisted_1
    ]),
    directions: _withCtx(() => [
      (!blueprints.value)
        ? (_openBlock(), _createBlock(LoadingIndicator, { key: 0 }))
        : (status.value === 'reset')
          ? (_openBlock(), _createBlock(LoadingIndicator, {
              key: 1,
              "loading-text": "Resetting demo..."
            }))
          : (status.value === 'building')
            ? (_openBlock(), _createBlock(LoadingIndicator, {
                key: 2,
                "loading-text": "Building demo..."
              }))
            : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                (status.value === 'error')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(TandemSelect, {
                    label: "Demo Instance",
                    options: blueprints.value,
                    "get-label": (bp) => bp.name,
                    "get-key": (bp) => bp.id,
                    modelValue: selectedBlueprint.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedBlueprint).value = $event))
                  }, null, 8, ["options", "get-label", "get-key", "modelValue"]),
                  (milestones.value)
                    ? (_openBlock(), _createBlock(TandemSelect, {
                        key: 0,
                        label: "Milestone",
                        options: milestones.value,
                        "get-label": (ms) => ms.name,
                        "get-key": (ms) => ms.id,
                        modelValue: selectedMilestone.value,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedMilestone).value = $event))
                      }, null, 8, ["options", "get-label", "get-key", "modelValue"]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", { class: "button-block" }, [
                    _createElementVNode("button", {
                      class: "btn btn-burg",
                      type: "button",
                      onClick: handleBuild
                    }, " Build ")
                  ])
                ])
              ]))
    ]),
    buttons: _withCtx(({ close }) => [
      _withDirectives(_createElementVNode("button", {
        class: "btn btn-close btn-circle-small",
        type: "button",
        "aria-label": "Close Modal",
        onClick: close
      }, null, 8, _hoisted_7), [
        [_vShow, status.value !== 'building']
      ])
    ]),
    _: 1
  }, 16))
}
}

})